module.exports = __webpack_public_path__ + "img/internet-2.14880751.jpg";